import { render, staticRenderFns } from "./AllocationCollectOnline.vue?vue&type=template&id=2f77d2f7&scoped=true"
import script from "./AllocationCollectOnline.vue?vue&type=script&lang=js"
export * from "./AllocationCollectOnline.vue?vue&type=script&lang=js"
import style0 from "./AllocationCollectOnline.vue?vue&type=style&index=0&id=2f77d2f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77d2f7",
  null
  
)

export default component.exports